import React, { useState, useContext } from 'react'
import { IonCard, IonCardHeader, IonCardTitle, IonCardContent, IonItem, IonLabel, IonInput, IonCol, IonRow, IonButton } from '@ionic/react'
import db from '../../resources/db'
import { toastController } from '@ionic/core'
import moment from 'moment'
import { useRouter } from '../../resources/Hooks'
import { APPLINKS } from '../../resources/AppConst'

const AddCustomer = (props) => {
    // console.log(props);
    const router = useRouter()
    const [customerName, setCustomerName] = useState('')
    const [customerDetails, setcustomerDetails] = useState('')
    const [customerContact, setCustomerContact] = useState('')
    const [date, setDate] = useState(Date())
    const [credit, setCredit] = useState(0)
    const [debit, setDebit] = useState(0)


    /** Add Data from Ledger */
    const addCustomerToLedger = e => {
        e.preventDefault();
        let billDate = moment(date).format('ll');
        // console.log(setDate);
        const data = {
            customerName,
            customerDetails: customerDetails ? customerDetails : "",
            customerContact: customerContact ? customerContact : "",
            customerGST: '',
            date: billDate,
            credit,
            debit,
            receivable: ((debit - credit) > 0) ? (debit - credit) : 0,
            payable: ((credit - debit) > 0) ? (credit - debit) : 0,
            isCustomer: 1, //true
        };
        data.cash = data.credit;


        db.ledger.put(data).then(res => {
            console.log("Ledger Generated", res);
            toastController.create({
                color: 'success',
                duration: 2000,
                message: `Customer data added successfully`,
                showCloseButton: true
            }).then(toast => {
                toast.present();
            });
        });

    };


    const onSubmit = (e) => {
        e.preventDefault()
        addCustomerToLedger(e)
        props.setModelOpen(false)
        router.push(`${APPLINKS.ledger}/${btoa(customerName)}`)

    }

    return (

        <form className='ion-padding' onSubmit={onSubmit}>
            <br /> 
            <IonCardTitle>Add Customer Details</IonCardTitle>
            <br /> <br />
            <IonRow>
                <IonCol>
                    <IonItem>
                        <IonLabel position='stacked'>Name</IonLabel>
                        <IonInput required type='text' id='customerName' onIonInput={e => { setCustomerName((e.target.value).trim()) }}></IonInput>
                    </IonItem>
                    <IonItem>
                        <IonLabel position='stacked'>Contact</IonLabel>
                        <IonInput type='text' id='customerContact' onIonInput={e => { setCustomerContact((e.target.value).trim()) }}></IonInput>
                    </IonItem>
                    <IonItem>
                        <IonLabel position='stacked'>Customer Details</IonLabel>
                        <IonInput type='text' id='customerDetails' onIonInput={e => { setcustomerDetails((e.target.value).trim()) }}></IonInput>
                    </IonItem>
                </IonCol>
                <IonCol>
                    <IonItem>
                        <IonLabel position='stacked'>Date</IonLabel>
                        <input type='date' id="date" value={moment(date).format('YYYY-MM-DD')} onChange={(e) => { setDate(e.target.value) }}></input>
                    </IonItem>

                    <IonItem>
                        <IonLabel position='stacked'>Opening Balance</IonLabel>
                        <IonInput required type='number' id='debit' value={debit} onIonInput={e => { setDebit(parseFloat(e.target.value)) }}></IonInput>
                    </IonItem>
                    <IonItem>
                        <IonLabel position='stacked'>Credit</IonLabel>
                        <IonInput required type='number' id='credit' value={credit} onIonInput={e => { setCredit(parseFloat(e.target.value)) }}></IonInput>
                    </IonItem>
                </IonCol>
            </IonRow>
            <br />
            <br />
            <br />


            <IonButton color='danger' expand='block' type='submit'>Add Customer</IonButton>
        </form>

    )
}

export default AddCustomer
